import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../types/global/routes.types';
import { getJWtDetails } from '../utils/AppUtils';
import { useSelector } from 'react-redux';
import {
    isAdminSelector,
    isUserCastingDirectorSelector,
    isUserJurySelector,
    userPermissionsSelector,
} from '../selectors/selectors';
import { E_USER_PERMISSIONS, UserPermissionLevels } from '../types/global/user.models';

interface IProtectedRoute {
    children: JSX.Element;
    accessCheck?: boolean;
    accessType?: UserPermissionLevels | UserPermissionLevels[]; // Support single or multiple
}

export const ProtectedRoute = ({ children, accessCheck, accessType }: IProtectedRoute) => {
    const { isSignedIn } = getJWtDetails();
    const location = useLocation();
    const isJuryEnabled = useSelector(isUserJurySelector);
    const isCastingDirector = useSelector(isUserCastingDirectorSelector);
    const isAdmin = useSelector(isAdminSelector);
    const userPermissions = useSelector(userPermissionsSelector);

    const checkAccess = (type: UserPermissionLevels) => {
        switch (type) {
            case E_USER_PERMISSIONS.JURY:
                return isJuryEnabled || userPermissions.includes(E_USER_PERMISSIONS.JURY);
            case E_USER_PERMISSIONS.CASTING_DIRECTOR:
                return isCastingDirector || userPermissions.includes(E_USER_PERMISSIONS.CASTING_DIRECTOR);
            case 'admin':
                return isAdmin || userPermissions.includes('admin');
            default:
                return userPermissions.includes(type);
        }
    };

    const hasValidAccess = () => {
        if (!accessCheck || !accessType) return true;

        if (Array.isArray(accessType)) {
            return accessType.some(type => checkAccess(type));
        }

        return checkAccess(accessType);
    };

    if (!isSignedIn) {
        return <Navigate to={`${ROUTES.ESLOGIN}?redirect=${encodeURIComponent(location.pathname)}`} />;
    }

    if (!hasValidAccess()) {
        return <Navigate to={ROUTES.FEED} />;
    }

    return children;
};
